module.exports = __webpack_public_path__ + "img/list-pattern2.1150532.svg";